import { useMemo } from 'react';

import { Input, Label, MultiSelect, Text, TypeSelectOption } from '@thefarmersfront/kitchen';

import { useShallow } from 'zustand/react/shallow';

import { useGetSuppliersConsignorCodeQuery } from '~/hooks/product';
import { useProductStore, useUserInfoStore } from '~/store';
import { transformToSelectOptions } from '~/utils';

import styles from './ProductRegisterModalDefaultSection.module.scss';

const ProductRegisterModalDefaultSection = () => {
  const { userInfo } = useUserInfoStore();
  const [
    productModalRequiredValueStatus,
    resetProductModalRequiredValueStatus,
    productRegisterModalValue,
    setProductRegisterModalValue,
    setFocusFieldRefs,
  ] = useProductStore(
    useShallow((state) => [
      state.productModalRequiredValueStatus,
      state.resetProductModalRequiredValueStatus,
      state.productRegisterModalValue,
      state.setProductRegisterModalValue,
      state.setFocusFieldRefs,
    ])
  );

  const suppliersCodeQuery = useGetSuppliersConsignorCodeQuery({
    consignorCode: userInfo.ownerCode ?? '',
    enabled: !!userInfo.ownerCode,
  });

  const productSuppliersOption = useMemo(
    () =>
      suppliersCodeQuery.data
        ? transformToSelectOptions(suppliersCodeQuery.data.data, 'supplierCode', 'supplierName')
        : [],
    [suppliersCodeQuery.data]
  );

  const handleClickSupplierSelect = () => {
    resetProductModalRequiredValueStatus('supplierCodes');
  };

  const handleChangeSupplierSelect = (_: unknown, value: TypeSelectOption[] | null) => {
    setProductRegisterModalValue({
      ...productRegisterModalValue,
      supplierCodes: (value as TypeSelectOption<string>[]) ?? [],
    });

    resetProductModalRequiredValueStatus('supplierCodes');
  };

  return (
    <div className={styles['default-info-section']}>
      <Text className={styles['section-title']} size="xxlarge" weight="bold">
        기본 정보
      </Text>
      <div className={styles['item-row']}>
        <Label className={styles['label']} title="화주사명" required />
        <div className={styles['input-wrapper']}>
          <Input disabled type="text" size="small" name="venderName" value={userInfo.ownerName} />
        </div>
      </div>
      <div className={styles['item-row']}>
        <Label className={styles['label']} title="공급사명" required />
        <div className={styles['input-wrapper']}>
          <MultiSelect
            ref={(el) => setFocusFieldRefs('supplierCodes', el)}
            size="small"
            options={productSuppliersOption}
            value={productRegisterModalValue.supplierCodes}
            placeholder="선택 (복수 선택 가능)"
            status={productModalRequiredValueStatus.supplierCodes?.status}
            validationMessage={productModalRequiredValueStatus.supplierCodes?.message}
            onClick={handleClickSupplierSelect}
            onChange={handleChangeSupplierSelect}
          />
        </div>
      </div>
    </div>
  );
};

export default ProductRegisterModalDefaultSection;
